import axios from 'axios';
import storage from './storage';

const API_URL =
  import.meta.env.VITE_API_URL ||
  (import.meta.env.PROD
    ? '/api'
    : 'http://localhost:10000/api');

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = storage.get('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      const isAuthMe = url.includes('/auth/me');
      const isAdminRoute = url.includes('/admin/');
      const isOnAdminPage = window.location.pathname.startsWith('/admin');

      // Clear token and redirect if auth/me fails OR any admin request fails with 401
      if (isAuthMe || (isAdminRoute && isOnAdminPage)) {
        console.warn('Unauthorized access detected — clearing session.');
        storage.remove('token');
        
        // Use a flag to prevent multiple redirects/reloads if multiple requests fail at once
        if (!window.isRedirecting) {
          window.isRedirecting = true;
          window.location.href = '/auth';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
